import * as React from 'react';
import { cn } from '../../utils';

interface GrainOverlayProps extends React.HTMLAttributes<HTMLDivElement> {
  opacity?: number;
}

const GrainOverlay = React.forwardRef<HTMLDivElement, GrainOverlayProps>(
  ({ opacity = 0.3, className, ...props }, ref) => (
    <div
      ref={ref}
      aria-hidden
      className={cn(
        'pointer-events-none fixed inset-0 z-50 animate-grain',
        className,
      )}
      style={{
        opacity,
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat',
        backgroundSize: '256px 256px',
      }}
      {...props}
    />
  ),
);
GrainOverlay.displayName = 'GrainOverlay';

export { GrainOverlay };
